/**
 * Отметка «только что переехало».
 *
 * После переноса элемент появляется на новом месте с коротким проявлением —
 * это ответ на вопрос «куда он делся». Без отметки карточка просто возникает
 * в другом углу экрана, и взгляд ищет её заново.
 *
 * Отметка живёт ровно столько, сколько идёт появление, и снимается сама:
 * иначе повторный перенос той же карточки не проиграл бы анимацию, потому
 * что класс уже стоял бы на месте.
 *
 * Это состояние показа, а не данных: на запросы и на содержимое оно не
 * влияет и при перезагрузке не восстанавливается.
 */

import { useCallback, useEffect, useRef, useState } from 'react';

/** Длительность появления — та же, что у .drop-landed в теме. */
const LANDING_MS = 200;

export function useLanded(): {
  landedId: string | null;
  markLanded: (itemId: string) => void;
} {
  const [landedId, setLandedId] = useState<string | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (timer.current) clearTimeout(timer.current);
    },
    [],
  );

  const markLanded = useCallback((itemId: string) => {
    if (timer.current) clearTimeout(timer.current);
    setLandedId(itemId);
    timer.current = setTimeout(() => setLandedId(null), LANDING_MS);
  }, []);

  return { landedId, markLanded };
}
